import { Component, OnInit } from '@angular/core';
import { ProjetService } from 'src/app/_services/projet/projet.service';
import { Projet } from 'src/app/Model/projet';

@Component({
  selector: 'app-projets',
  templateUrl: './projets.component.html',
  styleUrls: ['./projets.component.css']
})
export class ProjetsComponent implements OnInit {
  projet : Projet[]=[];
  constructor(private serviceProjet : ProjetService) { }

  ngOnInit(): void {
    this.afficheProjet();
  }
  afficheProjet()
  {
    this.serviceProjet.AfficherProjet().subscribe(res=>{
      this.projet = res;
     // console.log(this.projet);
    });

  }
}
